<div class="width100">
  <button (click)="onClick.emit()" *ngIf="!loading"
          [ngClass]="[isButtonEnabled(), 'custom-button']"
          [style.border-radius]="borderRadius"
          class="button-secondary button-with-image"
          type="submit">
    {{ title }}
    <div *ngIf="showArrow" class="i-image-to-flip"><i class="bi bi-arrow-right arrow-icon"></i></div>
  </button>

  <button *ngIf="loading" class="button-primary custom-button" disabled type="button">
    <span aria-hidden="true" class="spinner-border spinner-border-sm"></span>
    <span class="visually-hidden" role="status">Loading...</span>
  </button>
</div>
